import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=ec915bd4&scoped=true&"
import script from "./LanguageSwitch.vue?vue&type=script&lang=ts&"
export * from "./LanguageSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSwitch.vue?vue&type=style&index=0&id=ec915bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec915bd4",
  null
  
)

export default component.exports